import React from 'react';

export default class FileTypeImage extends React.Component {
    public render() {
        return <svg enableBackground="new 0 0 96 96" id="image" version="1.1" viewBox="0 0 96 96" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path d="M80,4H16C9.373,4,4,9.373,4,16v64c0,6.627,5.373,12,12,12h64c6.627,0,12-5.373,12-12V16C92,9.373,86.627,4,80,4z M12,80V16  c0-2.21,1.79-4,4-4h64c2.21,0,4,1.79,4,4v42.344l-20-20L18.343,84H16C13.79,84,12,82.21,12,80z M80,84H29.657L64,49.657l20,19.999  V80C84,82.21,82.21,84,80,84z"/>
            <path d="M32,20c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S38.627,20,32,20z M32,36c-2.209,0-4-1.791-4-4s1.791-4,4-4  s4,1.791,4,4S34.209,36,32,36z"/>
        </svg>;
    }
}